<script>
    export let messe;
</script>

<div>
    <h2>{messe.TE_Bez}</h2>
    <p class="location">
        {messe.TE_von_hh}:{String(messe.TE_von_mm).padStart(2, '0')} Uhr - {messe.RA_Bez}
    </p>
    <p class="person">
        {messe.PE_Titel || ''}
        {messe.PE_Vorname || ''}
        {messe.PE_Nachname || ''}
    </p>
    {#if messe.TE_FaelltAus}
        <p class="text-red-700">Fällt aus</p>
    {/if}
</div>

<style>
    div {
        @apply bg-white odd:bg-gray-50 p-2;
    }
    h2 {
        @apply font-semibold;
    }
</style>
